
<template>
  <v-layout wrap px-12 py-5>
    <v-flex>
      <vue-element-loading
        :active="appLoading"
        spinner="bar-fade-scale"
        color="#68D389"
        size="128"
        is-full-screen
      />
      <ServerError v-if="ServerError" />
      <div v-if="result !== false">
        <v-layout wrap v-for="(item, i) in result" :key="i" justify-start>
          <v-flex xs12 sm3>
            <router-link class="routerlink" :to="'/searchdata/' + item._id">
              <v-img
                width="507px"
                height="200px"
                cover
                :src="mediaURL + item.image"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color=" #FDAC53"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </router-link>
          </v-flex>
          <v-flex xs8 align-self-center px-4>
            <v-layout wrap>
              <v-flex v-if="item.turtle" xs12 style="color: red"
                ><b>
                  {{ item.turtle.name }}
                </b>
              </v-flex>
              <v-flex xs12 v-if="item.turtle"
                ><b>
                  {{ item.turtle.common_name }}
                </b>
              </v-flex>
              <v-flex v-if="item.turtle">
                <b> Type: {{ item.turtle.type }} </b>
              </v-flex>
              <v-flex xs12>
                {{ item.comment }}
              </v-flex>
              <v-flex xs12>
                <span> Condition: {{ item.condition }} </span>
                <span v-if="item.condition == null"> </span>
              </v-flex>

              <v-flex v-if="item.turtle">
                {{ item.turtle.habitat }}
              </v-flex>
              <v-flex xs12>
                {{ DateFormatted(item.createddate) }}
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex py-3 xs11><v-divider></v-divider> </v-flex>
        </v-layout>
      </div>
      <div v-else>
        <v-layout wrap justify-center>
          <v-flex text-center align-self-center>
            <span>Sorry!!No result found</span>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  // props: ["keyword"],
  data() {
    return {
      result: [],
      ServerError: false,
      appLoading: false,
      searchkey: null,
    };
  },
  watch: {
    keyword() {
      this.getNorm();
    },
  },

  mounted() {
    this.getNorm();
  },
  methods: {
    DateFormatted(params) {
      return params ? moment(params).format("DD-MM-Y") : "";
    },
    getNorm() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "report/search",
        params: {
          keyword: this.$route.query.searchkey,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.result = response.data.data;
            this.appLoading = false;
          } else {
            this.result = response.data.status;
            console.log(response.data.status);
            this.appLoading = false;
          }
          // this.appLoading = false;
        })
        .catch((err) => {
          console.log(err());
          this.ServerError = true;
        });
    },
  },
};
</script>